import { createContextStore } from "@faire/web/ui/hooks/ContextStore";

import { INITIAL_CART_PAGE_STORE } from "./consts";
import { CartPageStore } from "./types";

export const { useStore, Provider } = createContextStore<CartPageStore>(
  INITIAL_CART_PAGE_STORE,
  { name: "CartPageStore" }
);
